var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-10 mt-16 h-px w-full border-b md:my-16"})}
var staticRenderFns = []

export { render, staticRenderFns }